import classNames from "classnames"

import bgPng from "../../assets/img/record/tab-bg.png"
import bgWebP from "../../assets/img/record/tab-bg.webp"
import tag from "../../assets/img/record/tag.png"
import styles from "./index.module.less"

interface TabButtonProps {
    active?: boolean
    label?: string
    onClick?: () => void
    className?: string
    style?: React.CSSProperties
}

const TabButton: React.FC<TabButtonProps> = (props) => {
    const { active, label, onClick, className, style } = props

    return (
        <div
            className={classNames(
                styles.tabButton,
                active && styles.active,
                className
            )}
            onClick={onClick}
            style={style}
        >
            <picture>
                <source srcSet={bgWebP} type="image/webp" />
                <img src={bgPng} alt="tab-bg" />
            </picture>
            <div className={styles.wrapper} />
            <span>
                {label} <img src={tag} alt="" className={styles.tag} />
            </span>
        </div>
    )
}

export default TabButton
